import './ProjectItem.css';

function ProjectItem({ data }) {
  return (
    <div className="project__slider__slide" key={data.key}>
      <div>
        <div className="project__logo">
          {data.logo ? (
            <img src={`/images/${data.logo}`} alt={`Logo ${data.name}`}></img>
          ) : (
            <h2>{data.name}</h2>
          )}
          <p>{data.description}</p>
        </div>

        <div className="project__slider__popup">
          <p>{data.techs}</p>
          <div className="project__slider__links">
            <a href={data.url} target="_blank" rel="noreferrer">
              <i className="fas fa-link"></i>
            </a>
            {data.repo ? (
              <a href={data.repo} target="_blank" rel="noreferrer">
                <i className="fab fa-github-square"></i>
              </a>
            ) : (
              ''
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProjectItem;
